<template>
  <div id="app" class="app-content mb-4">
    <app-header></app-header>
    <div class="container">
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 text-center">
          <div class="amej-title">
            <h1>Remove Bank</h1>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <b-table
            show-empty
            :items="banks"
            :fields="fields"
            bordered
            :filter="filter"
            @filtered="onFiltered"
            responsive
          >
            <template v-slot:cell(S.N)="data">{{ data.index + 1 + '.' }}</template>

            <template v-slot:cell(bank_name)="row">{{ row.item.bank_name }}</template>
            <template v-slot:cell(account)="row">{{ row.item.account_number }}</template>
            <template v-slot:cell(actions)="row">
              <!-- <b-button variant="danger" @click="handleDeleteButton(program.id)">Delete</b-button> -->
              <b-button
                variant="outline-danger"
                v-b-modal.delete-modal
                @click="Bankdetail(row.item.id)"
              >Remove</b-button>
            </template>
          </b-table>

          <b-modal
            ref="modal"
            id="delete-modal"
            hide-footer
            no-close-on-esc
            no-close-on-backdrop
            hide-header-close
          >
            <template slot="modal-title">Are you sure to delete the bank?</template>
            <b-alert
              :show="dismissCountDown"
              dismissible
              variant="danger"
              @dismissed="dismissCountDown=0"
            >
              <div v-if="message">
                <p v-if="message.length>0">{{message}}</p>
              </div>
            </b-alert>

            <p class="text-danger" v-if="errors.password">{{errors.password}}</p>
            <b-container fluid class="text-center">
              <b-form-input
                type="password"
                v-model="password"
                placeholder="Enter your Password"
                class="mb-4"
              ></b-form-input>
              <b-button
                class="ml-3"
                variant="outline-danger"
                @click="handleDeleteButton(bankdetail_id.id)"
              >Yes</b-button>
              <b-button class="ml-3" variant="outline-secondary" @click="CloseModal()">No</b-button>
            </b-container>
          </b-modal>
        </div>
      </div>
    </div>

    <b-modal
      ref="loader_modal"
      id="loader_modal"
      class="loader_modal"
      size="sm"
      text-center
      headerClass="border-bottom-0"
      centered
      hide-footer
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
    >
      <div class="text-center p-4">
        <b-spinner variant="light" label="Text Centered"></b-spinner>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import AppHeader from "../reuseable_components/Header.vue";

export default {
  name: "RemoveBank",
  components: {
    "app-header": AppHeader,
  },

  computed: {
    ...mapState(["banks", "successmessage", "errormessage", "message"]),
  },

  data() {
    return {
      filter: null,
      totalRows: 1,
      password: "",
      bankdetail_id: "",
      errors: [],
      dismissSecs: 2,
      dismissCountDown: 0,
      countDownChanged: 0,
      fields: [
        { key: "S.N" },
        { key: "bank.bank_name", label: "Bank Name", sortable: true },
        { key: "account_number", label: "Account Number" },
        { key: "actions", label: "Actions" },
      ],
    };
  },
  created() {
    this.listBanks();
  },
  mounted: function () {
    if (this.$store.state.token == "") {
      this.$router.replace("/");
    }
  },
  methods: {
    ...mapActions(["listBanks"]),
    handleDeleteButton(bank_id) {
      this.errors = [];
      if (this.password == "") {
        this.errors["password"] = "Password required.";
      } else {
        // this.$refs['loader_modal'].show()
        this.$store
          .dispatch("deleteBank", { bank_id: bank_id, password: this.password })
          .then(() => {
            if (this.successmessage == "success") {
              window.location.replace("/removebank");
            } else if (this.errormessage == "errormessage") {
              this.dismissCountDown = this.dismissSecs;
              this.$router.replace({ name: "removebank" });
            }
          });
      }
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
    },

    CloseModal() {
      // this.$bvModal.hide('confirmation-modal')
      this.$refs.modal.hide();
    },

    Bankdetail(bank_id) {
      this.bankdetail_id = this.banks.find((evt) => evt.id == bank_id);
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../css/style.scss';
</style>
